import React from 'react';
import { Modal } from 'antd';

interface BaseModalProps {
  open: boolean;
  title?: React.ReactNode;
  onCancel?: () => void;
  closable?: boolean;
  maskClosable?: boolean;
  width?: number;
  children: React.ReactNode;
}

const BaseModal: React.FC<BaseModalProps> = ({
  open,
  title,
  onCancel,
  closable = false,
  maskClosable = false,
  width = 800,
  children,
}) => {
  return (
    <Modal
      open={open}
      title={title}
      onCancel={onCancel}
      footer={null}
      closable={closable}
      maskClosable={maskClosable}
      width={width}
    >
      {children}
    </Modal>
  );
};

export default BaseModal;
